/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { organizationGuestSchema } from "./organizationGuestSchema.ts";

export const orgOrganizationRetrievePathIdSchema = z.uuid();

export const orgOrganizationRetrieveStatus200Schema = organizationGuestSchema;

export const orgOrganizationRetrieveResponseSchema = orgOrganizationRetrieveStatus200Schema;
